/**
 * @generated SignedSource<<394710d9905389889da0ef843e93e9e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationsModule_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly items: ReadonlyArray<{
    readonly cmsId: number | null;
    readonly linkData: {
      readonly path: string | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModuleItem_item">;
  } | null> | null;
  readonly subtitle: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModuleItemList_componentModule">;
  readonly " $fragmentType": "HpSharedLocationsModule_componentModule";
};
export type HpSharedLocationsModule_componentModule$key = {
  readonly " $data"?: HpSharedLocationsModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationsModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedLocationsModuleItem_item"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedLocationsModuleItemList_componentModule"
    }
  ],
  "type": "LocationsModule",
  "abstractKey": null
};

(node as any).hash = "44468dc9cc2ee4bf41095ae16893605f";

export default node;
